import { createSelector } from 'reselect';

import { RootState } from '../types';

export const localeSelector = (state: RootState) => state.locale.locales;

export const daysLocaleSelector = createSelector(
  localeSelector,
  (locale) => locale.days
);

export const monthsLocaleSelector = createSelector(
  localeSelector,
  (locale) => locale.months
);

export const gamesLocaleSelector = createSelector(
  localeSelector,
  (locale) => locale.games
);

export const uiLocaleSelector = createSelector(
  localeSelector,
  (locale) => locale.roulette_ui
);

export const tableNamesLocaleSelector = createSelector(
  localeSelector,
  (locale) => locale.tableNames
);

export const disabledLocaleSelector = (state: RootState) => state.locale.isDisabled;
export const currentLocaleSelector = (state: RootState) => state.locale.lang;
export const localeLoadedSelector = (state: RootState) => state.locale.loaded;

export const localeStatusSelector = createSelector(
  disabledLocaleSelector,
  currentLocaleSelector,
  localeLoadedSelector,
  (disabled, lang, loaded) => ({ disabled, lang, loaded })
);
